module.exports = __webpack_public_path__ + "img/img-9bc3b0.jpg";